import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class SessionSyncService {
  private readonly router = inject(Router);
  private readonly channel = new BroadcastChannel('msal_session_sync');
  private readonly MSAL_KEY_PREFIX = 'msal.';

  constructor() {
    this.listen();
    // Tell existing tabs we need their session
    this.channel.postMessage({ type: 'NEW_TAB' });
  }

  private listen(): void {
    this.channel.addEventListener('message', ({ data }: MessageEvent) => {
      switch (data.type) {
        case 'NEW_TAB': {
          // In case of existing tab — collect and share MSAL keys
          const snapshot: Record<string, string> = {};
          for (let i = 0; i < sessionStorage.length; i++) {
            const key = sessionStorage.key(i);
            if (key.startsWith(this.MSAL_KEY_PREFIX)) {
              snapshot[key] = sessionStorage.getItem(key);
            }
          }
          if (Object.keys(snapshot).length > 0) {
            this.channel.postMessage({ type: 'SESSION_SNAPSHOT', snapshot });
          }
          break;
        }

        case 'SESSION_SNAPSHOT': {
          // I'm the new tab — only hydrate if I have nothing yet
          const alreadyHasSession = Array.from({ length: sessionStorage.length }).some((_, i) =>
            sessionStorage.key(i)?.startsWith(this.MSAL_KEY_PREFIX),
          );

          if (!alreadyHasSession) {
            for (const [key, value] of Object.entries<string>(data.snapshot)) {
              sessionStorage.setItem(key, value);
            }
          }
          break;
        }

        case 'SIGN_OUT': {
          sessionStorage.clear();
          void this.router.navigate(['/']);
          break;
        }
      }
    });
  }

  public broadcastSignOut(): void {
    this.channel.postMessage({ type: 'SIGN_OUT' });
  }
}
